<template>
  <v-dialog v-model="dialog" width="450">
    <v-card class="pa-2">
      <v-row class="pa-4" no-gutters>
        <v-col xs="6">
          <v-text-field
            v-model="quantity"
            :label="$t('parts.insert_parts.empty_parts.quantity')"
            type="number"
            min="1"
            max="100"
            oninput="validity.valid || (value = '')"
          />
        </v-col>
        <v-col xs="6">
          <v-row no-gutters class="pt-3 pl-2">
            <v-btn :loading="loading" color="primary" @click="insert">
              {{ $t("parts.insert_parts.empty_parts.create_parts") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import postRequest from "../../api/postRequest";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    quantity: null,
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.loading = false;
        this.quantity = null;
      }
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.quantity = null;
    },
    insert() {
      if (this.quantity) {
        this.loading = true;
        postRequest
          .object(
            `/temporary-part/insert/empty/multiple/${this.quantity}?user_id=${
              this.$store.getters.userId
            }&institution_id=${this.$store.getters.institutionId}`,
          )
          .then((response) => {
            if (response) {
              this.$emit("inserted");
              this.close();
            }
          })
          .catch((error) => {
            if (error) {
              this.close();
            }
          });
      }
    },
  },
};
</script>
